import { render, staticRenderFns } from "./WorkQueueAlert.vue?vue&type=template&id=03499a86&scoped=true&"
import script from "./WorkQueueAlert.vue?vue&type=script&lang=js&"
export * from "./WorkQueueAlert.vue?vue&type=script&lang=js&"
import style0 from "./WorkQueueAlert.vue?vue&type=style&index=0&id=03499a86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03499a86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VRow})
